<p>{{title}}</p>
<p-button 
    id="homeButton"
    label="Click" 
    icon="pi pi-check" 
    iconPos="left" 
    (onClick)="handleClick($event)"
></p-button>